import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Download = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C14.95 30 13.912 29.575 13.175 28.825L7.175 22.825C6.425 22.075 6 21.05 6 20C6 17.8 7.8 16 10 16C10.7 16 11.4 16.188 12 16.538V11.001C12 10.451 12.45 10.001 13 10.001H19C19.55 10.001 20 10.451 20 11.001V16.413C20.6 16.063 21.3 15.876 22 15.876C24.2 15.876 26 17.676 26 19.876C26 20.926 25.575 21.963 24.825 22.701L18.837 28.814C18.087 29.576 17.049 30.002 15.999 30.002L16 30ZM10 18C8.9 18 8 18.9 8 20C8 20.525 8.213 21.038 8.588 21.413L14.588 27.413C14.963 27.788 15.475 28 16 28C16.525 28 17.038 27.788 17.413 27.413L23.401 21.3C23.776 20.925 23.988 20.4 23.988 19.875C23.988 18.775 23.088 17.875 21.988 17.875C21.463 17.875 20.95 18.087 20.575 18.462L19.7 19.337C19.412 19.625 18.988 19.712 18.613 19.549C18.238 19.399 18 19.024 18 18.624V11.999H14V18.761C14 19.161 13.762 19.536 13.387 19.686C13.012 19.836 12.587 19.761 12.299 19.474L11.424 18.599C11.037 18.212 10.524 17.999 9.999 17.999L10 18Z" />
		<path d="M19 8H13C12.45 8 12 7.55 12 7V3C12 2.45 12.45 2 13 2H19C19.55 2 20 2.45 20 3V7C20 7.55 19.55 8 19 8ZM14 6H18V4H14V6Z" />
	</svg>
);

export default Download;
